import * as React from 'react';
import { HeaderLogoAndTel } from "../../../../HeaderLogoAndTel";
import { Modal } from "../../../../Modal";
import { Timer } from "../Timer";
import * as main from "../../main.module.scss";
import * as screen1 from "./style.module.scss";
import {WebDate} from "../../../../WebDate";
export const Screen1 = ({ id, widget }) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <section className={screen1.screen1}>
      <div className="container">
        <HeaderLogoAndTel/>
        <time><WebDate id={id}/></time>
        <p className={screen1.type}>Бесплатный мастер-класс</p>
        <h1>
          <p>Как выучить английский</p>
          <p>Новичку в кратчайшие сроки без зубрежки: для путешествий, работы и общего развития</p>
        </h1>
        <div className={screen1.wrapper}>
          <div className={screen1.info}>
            <Timer id={id} block={'screen1'}/>
            <div className={screen1.gift}>
              <img src="https://fs.advance.ru/landing-pages/webinar/kak_vyuchit_anglijskij_mk/gift.svg" alt=""/>
              <p className={screen1.giftInfo}>
                <span>В подарок —</span>
                <span>мини-курс «100&nbsp;английских слов для&nbsp;путешествий за&nbsp;2&nbsp;часа»</span>
                <span>Онлайн-курс для тех, кто хочет быстро и надолго запоминать иностранные слова</span>
              </p>
            </div>
            <a href="#widget" className={main.btn}>Занять место и получить подарок</a>
          </div>
          <img src="https://fs.advance.ru/landing-pages/webinar/kak_vyuchit_anglijskij_mk/bg-kva.png" alt=""/>
        </div>
      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        { widget }
      </Modal>
    </section>
  );
};
